export const AggregatorGameEnum = {
  PRODEGE: "PRODEGE",
  TYRADS: "TYRADS",
  ADGEM: "ADGEM",
  HANG_MY_ADS: "HANG_MY_ADS",
  MY_CHIPS: "MY_CHIPS",
  GREEDY_GAMES: "GREEDY_GAMES",
} as const

export const SourceGameEnum = {
  NATIVE: "NATIVE",
  ...AggregatorGameEnum,
} as const

export type SourceGameType = keyof typeof SourceGameEnum

export const SOURCE_GAME_OPTIONS = Object.values(SourceGameEnum)


